"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DropdownMenu = _interopRequireDefault(require("reactstrap/lib/DropdownMenu"));

var _dropdownUtils = _interopRequireWildcard(require("../lib/dropdownUtils"));

var _excluded = ["rightAligned"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownMenu = function DropdownMenu(_ref) {
  var rightAligned = _ref.rightAligned,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var items = props.items;
  var hasSubmenus = (0, _dropdownUtils.dropdownHasSubmenus)(items);
  return /*#__PURE__*/_react["default"].createElement(_DropdownMenu["default"], {
    tag: hasSubmenus ? "ul" : "div",
    right: rightAligned,
    style: !hasSubmenus ? {
      maxHeight: (0, _dropdownUtils.getMaxHeight)(props),
      overflowY: "auto"
    } : {
      overflow: "visible",
      maxHeight: "none"
    }
  }, new _dropdownUtils["default"](hasSubmenus).renderDropdownItems(props));
};

DropdownMenu.propTypes = {
  maxMenuHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  rightAligned: _propTypes["default"].bool,
  items: _propTypes["default"].array
};
DropdownMenu.displayName = "OrionDropdownMenu";
var _default = DropdownMenu;
exports["default"] = _default;